import {Provider} from "react-redux";
import {RouterProvider, useLocation} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import routes from "./routes";
import {store} from "./redux/Store";
import './locales/i18n';
import AxiosErrorInterceptor from "./components/AxiosErrorInterceptor";

export default function App() {

    return (
        <Provider store={store}>
            <AxiosErrorInterceptor  />
            <RouterProvider router={routes}/>
            <ToastContainer/>
        </Provider>
    );
}